import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { Nullable } from 'primeng/ts-helpers';

@Component({
  selector: 'app-label',
  styleUrls: ['./app-label.component.scss'],
  standalone: true,
  template: `
    <label [for]="for ?? controlName">
      <ng-content></ng-content>
      @if (required) {
        <span>*</span>
      }
    </label>
  `,
  styles: [
    `
      :host {
        display: contents;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppLabelComponent {
  @Input() for?: string;
  @Input() formGroup: Nullable<FormGroup>;
  @Input() controlName: Nullable<string>;

  get required(): boolean {
    return (
      this.formGroup
        ?.get(this.controlName ?? '')
        ?.hasValidator(Validators.required) ?? false
    );
  }
}
